export function isOverlayTriggerReady(el: HTMLElement | null | undefined): boolean {
  return !!el?.isConnected;
}
